module.exports = __webpack_public_path__ + "static/media/bg1.be744d60.jpg";